import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useOutletContext } from "react-router";
import { useDispatch } from "react-redux";
import MainLayout from "../../components/Common/MainLayout/MainLayout";
import {
  getClassInfoActionHandler,
  getTrendingClassesActionHandler,
  getUserClassInfoActionHandler,
  getUsersStatusActionHandler,
} from "../../store/actions/actionHandlers/dashboardActionHandler";
import { dashboard } from "../../utils/mainTabs/dashboard/dashboard";
import { tileSize } from "../../utils/tileSizes";
import { tileTypes } from "../../utils/tileTypes";
import Button from "../../components/Common/Button/Button";
import classes from "./DashboardPage.module.scss";
import HomeIcon from "../../components/Common/SvgIcons/SidebarIcons/HomeIcon";
import { colors } from "../../utils/stripeColors";
import RoleMenuChek from "../../hoc/RoleMenuCheck";
import { roleMenuList } from "../../utils/roleMenuList";
import { useSelector } from "react-redux";
import {
  getPublishedByMeActionHandler,
  getPublishedByOthersActionHandler
} from "../../store/actions/actionHandlers/manageActionHandler";
import { useFetchData } from "../../hooks/useFetchData";

const DashboardPage = () => {
  const pageSize = 8;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { tenantName } = useOutletContext();
  const [dashboardButtons, setDashboardButtons] = useState([]);
  const [dashboardTiles, setDashboardTiles] = useState([]);
  const [userClassInfo, setUserClassInfo] = useState(null);
  const [classInfo, setClassInfo] = useState(null);
  const [trendingClassInfo, setTrendingClassInfo] = useState(null);
  const [userStatusData, setUserStatusData] = useState([]);
  const commonState = useSelector((state) => state.commonReducer);
  const { myProfile, tenantPermissionsInfo } = commonState;
  const { name, tiles, buttons } = dashboard;
  const { PaneColor, PrimaryColor1 } = JSON.parse(
    localStorage.getItem("themeData")
  )?.CustomData;
  useEffect(() => {
    // dispatch(getUserClassInfoActionHandler()).then((response) => {
    //   setUserClassInfo(response);
    // });
    dispatch(getClassInfoActionHandler()).then((response) => {
      setClassInfo(response);
    });
    // dispatch(getTrendingClassesActionHandler()).then((response) => {
    //   setTrendingClassInfo(response);
    // });
  }, [dispatch]);

  const {
    totalRows : publishedByMeData
  } = useFetchData(getPublishedByMeActionHandler, pageSize);

  const {
    totalRows : publishedByOthersData
  } = useFetchData(getPublishedByOthersActionHandler, pageSize);

  useEffect(() => {
    dispatch(getUsersStatusActionHandler()).then((data) => {
      if (data.length > 0) {
        setUserStatusData(data);
      }
    });
  }, [dispatch, setUserStatusData]);

  useEffect(() => {
    // if (userClassInfo && classInfo && trendingClassInfo) {
    const dashboardTiles = tiles(
      tenantName,
      userClassInfo,
      classInfo,
      trendingClassInfo,
      userStatusData,
      publishedByMeData,
      publishedByOthersData
    );
    setDashboardTiles(dashboardTiles);
    // }
  }, [
    tiles,
    tenantName,
    userClassInfo,
    classInfo,
    trendingClassInfo,
    userStatusData,
    publishedByMeData,
    publishedByOthersData
  ]);
  useEffect(() => {
    const dashboardButtons = buttons(navigate, tenantName);
    setDashboardButtons(dashboardButtons);
  }, [buttons, tenantName, navigate]);
  const [hoveredCart, setHoveredCart] = useState(-1);
  const showCartHandler = (i) => {
    setHoveredCart(i);
  };
  const hideCartHandler = () => {
    setHoveredCart(-1);
  };
  const checkRolesAndPermissions = (menu) => {
    let isRolesAndPermissionFeatuePresent = false;
    const associatedRolesId = myProfile?.AssociatedRoles?.map(
      (data) => data?.RoleID
    );
    tenantPermissionsInfo?.forEach((permission) => {
      if (menu?.roleMenu === permission?.PermissionName) {
        associatedRolesId?.forEach((data) => {
          if (permission?.AssociatedRoles?.includes(data?.toString())) {
            isRolesAndPermissionFeatuePresent = true;
          }
        });
      }
    });
    return isRolesAndPermissionFeatuePresent;
  };
  return (
    <div className={classes.mainDiv}>
      <div className={classes.mainHomeDiv}>
        <div className={classes.title}>
          {/* <HomeIcon fill={"#404040;"} width={"2.5rem"} height={"2.5rem"} /> */}
          <h1>{name}</h1>
        </div>
        <div className={classes.mainHomeDivInner}>
          {dashboard?.buttons(navigate, tenantName).map((item, index) => {
            // debugger;
            const Icon = item?.icon;
            return (
              <div
                className={classes.innerDiv}
                style={{
                  color: hoveredCart === index ? "#fff" : "#404040",
                  border: `1px solid ${
                    hoveredCart === index ? PrimaryColor1 : "#404040"
                  }`,
                  borderRadius: "0.8rem",
                  gap: "0.5rem",
                  backgroundColor: hoveredCart === index ? PrimaryColor1 : "#fff",
                  display:
                    item?.menu && checkRolesAndPermissions(item?.menu)
                      ? ""
                      : !item?.menu
                      ? ""
                      : "none",
                }}
                // onMouseLeave={isFocused}
                // onMouseEnter={() => setFocus(-1)}
                onMouseLeave={hideCartHandler}
                onMouseEnter={() => showCartHandler(index)}
                onClick={item.onClick}
              >
                <Icon fill={hoveredCart === index ? "#fff" : PrimaryColor1} />{" "}
                {item?.label}
              </div>
            );
          })}
        </div>
      </div>
      <MainLayout
        // heading={name}
        // buttons={dashboardButtons}
        tiles={dashboardTiles}
        tileType={tileTypes.DEFAULT_WITH_ICON}
        tileSize={tileSize.LARGE}
      >
        <Outlet />
      </MainLayout>
    </div>
  );
};

export default DashboardPage;
